// extracted by css-extract-rspack-plugin
export default {"resultsPerPageSelect":"resultsPerPageSelect-jFdxN"};